module.exports = __webpack_public_path__ + "static/img/mark8.3e9b00a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/markdown/mark8.png
// module id = 5J5v
// module chunks = 0